import React from "react"
import autobind from "class-autobind"
import { ISchedulePatternTemplate, ISimpleTime, IScheduleShift, IJobDocument, IClientDocument, IDate } from "../../../models"
import { Dialog, FlatButton, SelectField, MenuItem, Divider, Toggle } from "material-ui"
import strings from "../../../localization/strings"
import AccountStore from "../../../stores/AccountStore"
import SimpleTimeEditor from "../../../components/common/SimpleTimeEditor"
import * as scheduleHelper from "../../../helpers/scheduleHelper"
import * as hierarchyHelper from "../../../helpers/hierarchyHelper"
import CreateSimplePositionShift from "../add_shift/CreateSimplePositionShift"
import _ from "lodash"
import * as utils from "../../../helpers/utils"
import * as userHelper from "../../../helpers/userHelper"
interface IProps {
  selectedDay: number
  // it's local time
  scheduleStartDate: IDate
  patternTemplate: ISchedulePatternTemplate
  handleAddShift(addedPatternTemplate: ISchedulePatternTemplate): void
  handleClose(): void
  scheduleJob: IJobDocument
  scheduleClient: IClientDocument
}
interface IState {
  selectedShift: IScheduleShift | "CreateNewShift"
  errorSelectedShift: string
  startTime: ISimpleTime
  endTime: ISimpleTime
  errorOverlap: string
  newShift: IScheduleShift
  overrideHierarchy: boolean
}

export default class AddShiftDialogForEveryEmployee extends React.Component<IProps, IState> {
  constructor(props) {
    super(props)
    this.state = {
      selectedShift: null,
      errorSelectedShift: "",
      startTime: null,
      endTime: null,
      errorOverlap: "",
      newShift: null,
      overrideHierarchy: false,
    }
    autobind(this)
  }

  checkValidate() {
    let isValidate = true
    if (!this.state.selectedShift) {
      this.setState({ errorSelectedShift: strings.This_field_is_required })
      isValidate = false
    }
    else {
      this.setState({ errorSelectedShift: "" })
      if (this.state.selectedShift === "CreateNewShift" && !this.state.newShift) {
        isValidate = false
      }
      else {
        let newShift = this.state.selectedShift === "CreateNewShift" ? _.cloneDeep(this.state.newShift) : _.cloneDeep(this.state.selectedShift) as IScheduleShift
        newShift.StartTime = this.state.startTime
        newShift.EndTime = this.state.endTime
        let patternTemplate = _.cloneDeep(this.props.patternTemplate)
        patternTemplate.ShiftTemplates.push(newShift)
        patternTemplate = scheduleHelper.updatePatternTemplateTimeForDay(this.props.scheduleStartDate, this.props.selectedDay, patternTemplate)
        newShift = patternTemplate.ShiftTemplates[patternTemplate.ShiftTemplates.length - 1]
        if (scheduleHelper.checkOverlapShifts(newShift, this.props.patternTemplate.ShiftTemplates)) {
          this.setState({ errorOverlap: "" })
        }
        else {
          this.setState({ errorOverlap: strings.Shift_time_is_overlapped })
          isValidate = false
        }
      }
    }
    return isValidate
  }

  handleSave() {
    if (!this.checkValidate()) return
    let newShift = _.cloneDeep(this.state.selectedShift === "CreateNewShift" ? this.state.newShift : this.state.selectedShift)
    if (this.state.selectedShift !== "CreateNewShift") {
      newShift = scheduleHelper.overrideShiftTemplateHierarchy(newShift, this.props.patternTemplate.HierarchyId, this.props.scheduleJob, this.props.scheduleClient)
    }
    newShift.Id = utils.guid()
    newShift.StartTime = this.state.startTime
    newShift.EndTime = this.state.endTime
    const patternTemplate = _.cloneDeep(this.props.patternTemplate)
    patternTemplate.ShiftTemplates.push(newShift)
    this.props.handleAddShift(scheduleHelper.updatePatternTemplateTimeForDay(this.props.scheduleStartDate, this.props.selectedDay, patternTemplate))
  }

  render() {
    return (
      <Dialog
        open={true}
        title={strings.Add_Shift}
        titleStyle={{ paddingLeft: 35, paddingBottom: 10 }}
        actions={[
          <FlatButton
            data-intercom-target={"Shift-AddShiftForEveryEmployee-Btn-CloseAddShiftDialog"}
            label={strings.CANCEL}
            secondary={true}
            onClick={this.props.handleClose}
          />,
          <FlatButton
            data-intercom-target={"Shift-AddShiftForEveryEmployee-Btn-SaveShift"}
            label={strings.SAVE}
            primary={true}
            onClick={this.handleSave}
          />
        ]}
      >
        <hr />
        <div style={{ paddingRight: 20, paddingLeft: 20 }}>
          <Toggle
            data-intercom-target={"Shift-AddShiftForEveryEmployee-Toggle-OverrideHierarchy"}
            label={strings.Override_hierarchy}
            toggled={this.state.overrideHierarchy}
            style={{ width: 225, marginTop: 25 }}
            onToggle={(e, value) => this.setState({ overrideHierarchy: value, selectedShift: null })}
          />
          <SelectField
            data-intercom-target={"Shift-AddShiftForEveryEmployee-Select-Shift"}
            floatingLabelText={strings.Shift}
            style={{ width: 250 }}
            value={this.state.selectedShift}
            onChange={(e, key, selectedShift) =>
              this.setState({
                selectedShift,
                startTime: selectedShift === "CreateNewShift" ? null : selectedShift.StartTime,
                endTime: selectedShift === "CreateNewShift" ? null : selectedShift.EndTime,
                errorOverlap: "",
                newShift: null
              }, () =>
                this.checkValidate()
              )}
            errorText={this.state.errorSelectedShift}
            errorStyle={{ position: "absolute", bottom: -10 }}
          >
            <MenuItem value={"CreateNewShift"} primaryText={strings.Create_new_shift} />
            <Divider />
            {utils.sortAlphabetical(AccountStore.getCurrentAccount().ScheduleData.ShiftTemplates, "Name").filter((item) =>
              !item.Deleted &&
              (this.state.overrideHierarchy ?
                userHelper.getSupervisorAccessHierarchyIds().includes(item.HierarchyId) :
                hierarchyHelper.getHierarchyIdsForShowAllChildHierarchyData(true, this.props.patternTemplate.HierarchyId).includes(item.HierarchyId)
              ) &&
              !this.props.patternTemplate.ShiftTemplates.find((existItem) => existItem.Id === item.Id))
              .map((item, index) =>
                <MenuItem value={item} primaryText={item.Name} key={index} />
              )}
          </SelectField>
          <div style={{ height: 60 }}>
            {this.state.selectedShift === "CreateNewShift" &&
              <CreateSimplePositionShift
                shiftTemplate={this.state.newShift}
                hierarchyId={this.props.patternTemplate.HierarchyId}
                handleSave={(newShift) => this.setState({ newShift, startTime: newShift ? newShift.StartTime : null, endTime: newShift ? newShift.EndTime : null }, () => this.checkValidate())}
                scheduleJob={this.props.scheduleJob}
                scheduleClient={this.props.scheduleClient}
              />
            }
          </div>
          <div style={{ display: "flex", height: 75 }}>
            {((this.state.selectedShift === "CreateNewShift" && this.state.newShift) || (this.state.selectedShift && this.state.selectedShift !== "CreateNewShift")) && [
              <div key="starttime">
                <SimpleTimeEditor
                  label={strings.Start_Time}
                  simpleTime={this.state.startTime}
                  handleChange={(startTime) => this.setState({ startTime }, () => this.checkValidate())}
                />
              </div>,
              <div style={{ marginLeft: 25 }} key="endtime">
                <SimpleTimeEditor
                  label={strings.End_Time}
                  simpleTime={this.state.endTime}
                  handleChange={(endTime) => this.setState({ endTime }, () => this.checkValidate())}
                />
              </div>
            ]}
          </div>
          <div style={{ height: 10, color: "red" }}>{this.state.errorOverlap}</div>
        </div>
      </Dialog>
    )
  }
}